import { EquipmentMasterData } from './EquipmentMasterData'
import { IEquipmentMasterDataWithDocCountDTO } from './IEquipmentMasterDataWithDocCountDTO'

/** Equipment data shown on "My equipments" page for partners */
export class PartnerEquipmentRow extends EquipmentMasterData {
    constructor(device: IEquipmentMasterDataWithDocCountDTO, localizer?: ((id: string) => string)) {
        super(device.equipment, localizer)
        this.docCount = device.docCount
    }

    readonly docCount: number
}